import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Standard lead time (business days, excluding Saturdays and Sundays) before a requested completion date. */
export const REQUIRED_DATE_LEAD_DAYS = 6;

/**
 * Formats a Date as a local YYYY-MM-DD string, matching `<input type="date">`.
 */
export function toDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Minimum selectable requested completion date.
 * Standard cases need a 6-business-day lead time; rush cases can be requested sooner.
 */
export function getMinimumRequiredDate(rushCase: boolean, now: Date = new Date()): string {
  const minimum = new Date(now);
  if (!rushCase) {
    let businessDays = 0;
    while (businessDays < REQUIRED_DATE_LEAD_DAYS) {
      minimum.setDate(minimum.getDate() + 1);
      const day = minimum.getDay();
      if (day !== 0 && day !== 6) businessDays += 1;
    }
  }
  return toDateInputValue(minimum);
}
